import React from 'react'
import './index.scss';

import logoMarcas from '../../assets/images/posventa/logoMarcas.png';
import LogoServiceOficial from '../../assets/images/posventa/LogoServiceOficial.png';

export const Header = () => {
  return (
    <section className='contenedorHeader'>
      <img src={LogoServiceOficial} alt="Logo Montironi" />
      <img src={logoMarcas} alt="Logo Marcas Montironi" className='OcultarCelular' />
      <p className='badegSucursalFlotante'>SUCURSAL: Pedro J. Frías 175, Jesus María, Córdoba </p>
    </section>
  )
}
